import api from '../../config/axios-interceptor';

export async function fetchAdminProfileApi() {
    return await api.get('/api/v1/admin/profile');
}

export async function fetchOperatorProfileApi() {
    return await api.get('/api/v1/operator/profile');
}
